import { render, staticRenderFns } from "./RecieveDetail.vue?vue&type=template&id=6cc981a6&scoped=true&"
import script from "./RecieveDetail.vue?vue&type=script&lang=ts&"
export * from "./RecieveDetail.vue?vue&type=script&lang=ts&"
import style0 from "./RecieveDetail.vue?vue&type=style&index=0&id=6cc981a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc981a6",
  null
  
)

export default component.exports